import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "two-column-input",
  templateUrl: "two-column-input.component.html",
})
export class TwoColumnInputComponent {
  // Inputs
  @Input() formGroup: FormGroup;
  @Input() isReadOnly: boolean = false;
  // OPTIONAL: Left Column - Input
  @Input() leftColumnInputControlName?: string;
  @Input() leftColumnInputLabel?: string;
  @Input() leftColumnInputPlaceholder?: string;
  @Input() leftColumnInputMaxLength?: number = 100;
  // OPTIONAL: Left Column - Text Area
  @Input() leftColumnTextAreaControlName?: string;
  @Input() leftColumnTextAreaLabel?: string;
  @Input() leftColumnTextAreaMaxLength?: number = 6000;
  @Input() leftColumnTextAreaRows?: number = 4;
  // OPTIONAL: Right Column - Input
  @Input() rightColumnInputControlName?: string;
  @Input() rightColumnInputLabel?: string;
  @Input() rightColumnInputPlaceholder?: string;
  @Input() rightColumnInputMaxLength?: number = 100;
  // OPTIONAL: Right Column - Text Area
  @Input() rightColumnTextAreaControlName?: string;
  @Input() rightColumnTextAreaLabel?: string;
  @Input() rightColumnTextAreaMaxLength?: number = 6000;
  @Input() rightColumnTextAreaRows?: number = 4;

  // Instance Variables
  private showLeftColumnInput: boolean = false;
  private showLeftColumnTextArea: boolean = false;
  private showRightColumnInput: boolean = false;
  private showRightColumnTextArea: boolean = false;

  ngOnInit(): void {
    // Left Column - Input
    this.showLeftColumnInput = this.shouldShowLeftColumnInput();
    if (this.showLeftColumnInput) {
      const leftColumnInputControl = this.formGroup.get(
        this.leftColumnInputControlName
      );
      if (leftColumnInputControl && !leftColumnInputControl.value) {
        leftColumnInputControl.setValue("");
      }
    }

    // Left Column - Text Area
    this.showLeftColumnTextArea = this.shouldShowLeftColumnTextArea();
    if (this.showLeftColumnTextArea) {
      const leftColumnTextAreaControl = this.formGroup.get(
        this.leftColumnTextAreaControlName
      );
      if (leftColumnTextAreaControl && !leftColumnTextAreaControl.value) {
        leftColumnTextAreaControl.setValue("");
      }
    }

    // Right Column - Input
    this.showRightColumnInput = this.shouldShowRightColumnInput();
    if (this.showRightColumnInput) {
      const rightColumnInputControl = this.formGroup.get(
        this.rightColumnInputControlName
      );
      if (rightColumnInputControl && !rightColumnInputControl.value) {
        rightColumnInputControl.setValue("");
      }
    }

    // Right Column - Text Area
    this.showRightColumnTextArea = this.shouldShowRightColumnTextArea();
    if (this.showRightColumnTextArea) {
      const rightColumnTextAreaControl = this.formGroup.get(
        this.rightColumnTextAreaControlName
      );
      if (rightColumnTextAreaControl && !rightColumnTextAreaControl.value) {
        rightColumnTextAreaControl.setValue("");
      }
    }
  }

  private shouldShowLeftColumnInput(): boolean {
    return !!(
      this.leftColumnInputControlName &&
      this.leftColumnInputLabel &&
      this.leftColumnInputPlaceholder
    );
  }

  private shouldShowLeftColumnTextArea(): boolean {
    return !!(
      this.leftColumnTextAreaControlName && this.leftColumnTextAreaLabel
    );
  }

  private shouldShowRightColumnInput(): boolean {
    return !!(
      this.rightColumnInputControlName &&
      this.rightColumnInputLabel &&
      this.rightColumnInputPlaceholder
    );
  }

  private shouldShowRightColumnTextArea(): boolean {
    return !!(
      this.rightColumnTextAreaControlName && this.rightColumnTextAreaLabel
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/two-column-input/two-column-input.component.ts